import { render, staticRenderFns } from "./TicketSystemFaqItem.vue?vue&type=template&id=0095edf4&scoped=true"
import script from "./TicketSystemFaqItem.vue?vue&type=script&lang=js"
export * from "./TicketSystemFaqItem.vue?vue&type=script&lang=js"
import style0 from "./TicketSystemFaqItem.vue?vue&type=style&index=0&id=0095edf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0095edf4",
  null
  
)

export default component.exports